module.exports = __webpack_public_path__ + "img/r6c1.d3dc17f5.jpg";